import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { catchError, map, Observable, of } from 'rxjs';
import { PromoResult } from '../../models/promo.code.model';

@Injectable({
  providedIn: 'root',
})
export class PromoCodeService {
  private readonly http = inject(HttpClient);

  public shouldShowPromoCodeFunctionality(promoCode: string): Observable<boolean> {
    if (promoCode.toLowerCase().startsWith('fas-') || promoCode.toLowerCase().startsWith('fao-')) {
      return of(false);
    }

    if (this.isKwkCode(promoCode)) {
      return of(true);
    }

    return this.validatePromoCode(promoCode).pipe(
      map(({ valid, historic }) => {
        return valid || historic;
      }),
    );
  }

  public checkPromoCode(promoCode: string): Observable<boolean> {
    if (this.isKwkCode(promoCode)) {
      return of(true);
    }

    return this.validatePromoCode(promoCode).pipe(
      map(({ valid }) => {
        return valid;
      }),
    );
  }

  private validatePromoCode(promoCode: string) {
    return this.http
      .get<PromoResult>(`${environment.apihost}/api/promocode/check2`, {
        params: {
          promoCode,
        },
      })
      .pipe(catchError(() => of({ valid: false, historic: false, message: 'Der von Dir angegebene Code ist nicht gültig' })));
  }

  private isKwkCode(promoCode: string) {
    return promoCode.toLowerCase().startsWith('kwk-');
  }
}
